import React from 'react';
import classnames from 'classnames';
import { isEmpty, get, indexOf, forEach} from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Typeahead } from 'modules/typeahead';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { multiSelectFormField as MultiSelectFormField } from 'ui/views/generic/multiSelectFormField';
 *
 * // render
 * <MultiSelectFormField propName='propValue'/>
 */
export const multiSelectFormField = ( props ) => {

     // get error message (ref)
     const errorMessage = get( props.error, 'message', null );
     const hasError = ! isEmpty( errorMessage );
 
     // dynamic class name
     const widgetClassName = classnames( 'ui-multi-select-form-field', props.className, {
         'ui-multi-select-form-field--error': hasError,
     } );

    let placeholder = getLabel( get( props, 'placeholder' ) );

    const updateValuesOnChange = get( props, 'config.updateValuesOnChange', false );

    let updatedValuesObj = {};

    if ( updateValuesOnChange ) {

        updatedValuesObj = {
            selected: !isEmpty( props.value ) ? props.value : [],
            disabled: props.disabled || false
        };
    }

    // update placeholder with the selected values
    if( ! isEmpty( props.value ) ) {

        const selectedValues = [];

        forEach( props.options, item => {
            if ( -1  !== indexOf( props.value, item.value ) ) {
                selectedValues.push( item.title.value );
            }
        } );

        const returnArray = selectedValues.join( ', ' );
        placeholder = returnArray;
    }

    return (
        <div className={ widgetClassName }>
            <div className='ui-multi-select-form-field'>
                {/* label */}
                <div className='ui-multi-select-form-field__label'>
                    {/* label text */}
                    <div className='ui-multi-select-form-field__label__text'>{ getLabel( props.label ) }</div>

                    {/* required asterisk */}
                    {
                        props.required ? (
                            <div className='ui-multi-select-form-field__label__asterisk'>*</div>
                        ) : null
                    }
                </div>

                {/* select */}
                <div className='ui-multi-select-form-field__select'>
                    <Typeahead
                        allowFilter= { props.allowFilter }
                        placeholder={ placeholder  }
                        useFocusEvent = { true }
                        useBlurEvent = { false }
                        searchable= { false }

                        // multiSelect={ true  }
                        type={ 'multiSelect' }
                        options= { props.options }
                        onChange={ ( { selected } ) => props.onChange( {
                            name: props.name,
                            value: selected,
                        } ) }
                        updateOptionsOnChange = { get( props, 'config.updateOptionsOnChange', false ) }
                        updateValuesOnChange = { updateValuesOnChange }
                        { ...updatedValuesObj }
                    />
                </div>
            </div>

            {/* error message */}
            {
                hasError ? (
                    <div className='ui-multi-select-form-field__error'>
                        <div className='ui-multi-select-form-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

// set display name
multiSelectFormField.displayName = 'multiSelectFormField';

// set default props
multiSelectFormField.defaultProps = {};

// prop types
multiSelectFormField.propTypes = {};
